module.exports = __webpack_public_path__ + "media/images/pages/clients-e1748561000c036eea6db042f42e7ed1.svg";